"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ReviewClipboard_exports = {};
__export(ReviewClipboard_exports, {
  default: () => ReviewClipboard_default
});
module.exports = __toCommonJS(ReviewClipboard_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.8242 3.16016C12.8242 3.09505 12.7982 3.04297 12.7461 3.00391C12.707 2.95182 12.6549 2.92578 12.5898 2.92578H8.41016C8.34505 2.92578 8.28646 2.95182 8.23438 3.00391C8.19531 3.04297 8.17578 3.09505 8.17578 3.16016V4C8.17578 4.0651 8.19531 4.1237 8.23438 4.17578C8.28646 4.22786 8.34505 4.25391 8.41016 4.25391H12.5898C12.6549 4.25391 12.707 4.22786 12.7461 4.17578C12.7982 4.1237 12.8242 4.0651 12.8242 4V3.16016ZM7.16016 3.16016C7.16016 2.82161 7.28385 2.52865 7.53125 2.28125C7.77865 2.03385 8.07161 1.91016 8.41016 1.91016H12.5898C12.9284 1.91016 13.2214 2.03385 13.4688 2.28125C13.7161 2.52865 13.8398 2.82161 13.8398 3.16016H15.5C15.9557 3.16016 16.3464 3.32292 16.6719 3.64844C16.9974 3.97396 17.1602 4.37109 17.1602 4.83984V8.58984H16.1641V4.83984C16.1641 4.65755 16.099 4.5013 15.9688 4.37109C15.8385 4.24089 15.6823 4.17578 15.5 4.17578H13.8203C13.7812 4.47526 13.6445 4.72917 13.4102 4.9375C13.1758 5.14583 12.9023 5.25 12.5898 5.25H8.41016C8.09766 5.25 7.82422 5.14583 7.58984 4.9375C7.35547 4.72917 7.21875 4.47526 7.17969 4.17578H5.5C5.31771 4.17578 5.16146 4.24089 5.03125 4.37109C4.90104 4.5013 4.83594 4.65755 4.83594 4.83984V16.5C4.83594 16.6823 4.90104 16.8385 5.03125 16.9688C5.16146 17.099 5.31771 17.1641 5.5 17.1641H8.83984V18.1602H5.5C5.04427 18.1602 4.65365 17.9974 4.32812 17.6719C4.0026 17.3464 3.83984 16.9557 3.83984 16.5V4.83984C3.83984 4.37109 4.0026 3.97396 4.32812 3.64844C4.65365 3.32292 5.04427 3.16016 5.5 3.16016H7.16016ZM15.5781 16.0312L17.2383 17.6914C17.3294 17.7826 17.4401 17.8281 17.5703 17.8281C17.7135 17.8281 17.8372 17.7826 17.9414 17.6914C18.0326 17.5872 18.0781 17.4701 18.0781 17.3398C18.0781 17.1966 18.0326 17.0794 17.9414 16.9883L16.2812 15.3281C16.5547 14.9635 16.7695 14.5664 16.9258 14.1367C17.082 13.694 17.1602 13.2318 17.1602 12.75C17.1602 12.1771 17.056 11.6367 16.8477 11.1289C16.6263 10.6211 16.3268 10.1784 15.9492 9.80078C15.5716 9.42318 15.1289 9.1237 14.6211 8.90234C14.1133 8.69401 13.5729 8.58984 13 8.58984C12.4271 8.58984 11.8867 8.69401 11.3789 8.90234C10.8711 9.1237 10.4284 9.42318 10.0508 9.80078C9.67318 10.1784 9.3737 10.6211 9.15234 11.1289C8.94401 11.6367 8.83984 12.1771 8.83984 12.75C8.83984 13.3229 8.94401 13.8633 9.15234 14.3711C9.3737 14.8789 9.67318 15.3216 10.0508 15.6992C10.4284 16.0768 10.8711 16.3763 11.3789 16.5977C11.8867 16.806 12.4271 16.9102 13 16.9102C13.4818 16.9102 13.9375 16.832 14.3672 16.6758C14.8099 16.5195 15.2135 16.3047 15.5781 16.0312ZM16.1641 12.75C16.1641 13.6224 15.8516 14.3711 15.2266 14.9961C14.6146 15.6081 13.8724 15.9141 13 15.9141C12.1276 15.9141 11.3789 15.6081 10.7539 14.9961C10.1419 14.3711 9.83594 13.6224 9.83594 12.75C9.83594 11.8776 10.1419 11.1354 10.7539 10.5234C11.3789 9.89844 12.1276 9.58594 13 9.58594C13.8724 9.58594 14.6146 9.89844 15.2266 10.5234C15.8516 11.1354 16.1641 11.8776 16.1641 12.75Z",
      fill: "currentColor"
    }
  )
);
const SvgReviewClipboard = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ReviewClipboard_default = SvgReviewClipboard;
